export const selectSalesSeason = (state) => state.seasons.sales;
